"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentSkeleton = void 0;
const react_1 = __importDefault(require("react"));
const Theme_1 = require("../../Theme/Theme");
const Spinner_1 = require("../Spinner/Spinner");
const ThumbnailBody = Theme_1.styled.div `
  position: relative;
  &:hover .cloverThumbnailLabel {
    font-weight: bold;
  }
  &:hover .cloverThumbnailImageOverlay {
    background-color: #222;
    border-radius: 3px;
  }

  &:hover .cloverThumbnailImage {
    opacity: 0.4;
  }

  &:hover .cloverThumbnailRemove {
    display: block;
  }

  width: ${(props) => (props.size ? `${props.size}px;` : '100px;')};
  height: ${(props) => (props.size ? `${props.size}px;` : '100px;')};
`;
const ThumbnailLabel = Theme_1.styled.div `
  width: ${(props) => (props.size ? `${props.size}px;` : '100px;')};
  font-size: 13px;
  margin-top: 0.5em;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  white-space: nowrap;
  color: ${(props) => props.lightBackground ? props.theme.gray2 : props.theme.white};
`;
const ThumbnailSkeleton = Theme_1.styled.div `
  border-radius: 3px;
  width: ${(props) => (props.size ? `${props.size}px;` : '100px;')};
  height: ${(props) => (props.size ? `${props.size}px;` : '100px;')};
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: row;
  align-items: center;
  background-color: lightgrey;
`;
exports.DocumentSkeleton = (props) => {
    return (react_1.default.createElement(ThumbnailBody, Object.assign({}, props),
        react_1.default.createElement(ThumbnailSkeleton, { size: props.size },
            react_1.default.createElement(Spinner_1.Spinner, { size: props.size ? '25' : '50' })),
        props.name && react_1.default.createElement(ThumbnailLabel, Object.assign({}, props), props.name)));
};
//# sourceMappingURL=DocumentSkeleton.js.map